import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { APP_ROUTES } from "../../contants/APP_ROUTES";
import { AUTH } from "../../contants/AUTH";
import { ROLES } from "../../contants/ROLES";
import { Helper } from "../../helpers/Helper";
import { Navigation } from "../../models/navigations/navigation";
import { AuthenticationService } from "../../services/authentication.service";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent implements OnInit {
  quickLinks: Navigation[] = [];
  routes = APP_ROUTES;

  showMobileNav: boolean = false;
  showManageNav: boolean = false;

  fullName: string = "";
  isManager: boolean = false;
  isBookkeeper: boolean = false;
  showNavigation: boolean = false;

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (!this._elementRef.nativeElement.contains(event.target)) {
      this.showManageNav = false;
      this.showMobileNav = false;
    }
  }

  constructor(
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _elementRef: ElementRef
  ) {
    _router.events.subscribe((event) => {
      let userRole = localStorage.getItem(AUTH.userRole);
      if (userRole) {
        var url: string = event["url"];
        if (url) {
          if (url.indexOf("dailytrip") !== -1 && url.indexOf("ticket") !== -1)
            this.showNavigation = false;
          else this.showNavigation = true;
        }
      } else {
        this.showNavigation = false;
      }
    });
  }

  ngOnInit() {
    this._authenticationService.isTokenExpired();
    this._authenticationService.isLoggedIn.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.loadNav();
        this.isManager = Helper.isManager();
        if(!this.isManager){
          this.isBookkeeper = Helper.isBookkeeper();
        }
        this.showNavigation = true;
      } else {
        this.showNavigation = false;
        this.isManager = false;
      }
    });
  }

  loadNav() {
    this.fullName = localStorage.getItem(AUTH.userFullName);
    this.quickLinks = [];

    let role = localStorage.getItem(AUTH.userRole);
    if (role == ROLES.manager || role == ROLES.tracking) {
      this.quickLinks = [
        { url: APP_ROUTES.tripList, title: "TRIPS", parameters: {} },
        { url: APP_ROUTES.dailyTripList, title: "DAILY TRIPS", parameters: {} },
        { url: APP_ROUTES.expenseList, title: "EXPENSES", parameters: {} },
        { url: APP_ROUTES.cashAdvanceList, title: "VALE", parameters: {} },
        { url: APP_ROUTES.tripPaymentList, title: "PAYMENTS", parameters: {} },
        { url: APP_ROUTES.dashboardBookkeeper, title: "DISPATCHER DASHBOARD", parameters: {} },
      ];
    } else if (role == ROLES.bookKeeper) {
      this.quickLinks = [
        { url: APP_ROUTES.dailyTripList, title: "DAILY TRIPS", parameters: {} },
        { url: APP_ROUTES.expenseList, title: "EXPENSES", parameters: {} },
        { url: APP_ROUTES.cashAdvanceList, title: "VALE", parameters: {} },
      ];
    } else if (role == ROLES.accountant) {
      this.quickLinks = [
        {
          url: APP_ROUTES.salaryReport,
          title: "EMPLOYEE SALARIES",
          parameters: {},
        },
        { url: APP_ROUTES.payrollList, title: "PAYROLL", parameters: {} },
      ];
    }
  }

  toggleMobileNav() {
    this.showMobileNav = !this.showMobileNav;
    if (this.showMobileNav) {
      this.showManageNav = false;
    }
  }

  toggleManageNav() {
    this.showManageNav = !this.showManageNav;
    if (this.showManageNav) {
      this.showMobileNav = false;
    }
  }

  onProfileClick() {
    this._router.navigate([APP_ROUTES.userProfile.replace("/:id", ""), 0]);
  }

  onSignOutClick() {
    this._authenticationService.logout();
    this.fullName = "";
    this._router.navigate([APP_ROUTES.login]);
  }

  onHomeClick() {
    if (this.isManager) {
      //route here
      return;
    }

    //route here
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/navigation.component.ts